import { Component } from "react";
import Typography from "@mui/material/Typography";
import { withStyles } from "@mui/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";

const styles = {
    card: {
        margin: "10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: "10px",
    },
    cardTitle: {
        fontSize: 12,
        fontWeight: "bold",
        fontFamily: "EDF2020_Bold",
        width: "100%",
    },
    cardContent: {
        padding: 0,
        width: "100%",
        textAlign: "center",
        maxHeight: "80px",
    },
    button: {
        marginLeft: "auto",
        marginRight: "auto",
        display: "block",
        width: "100%",
        "&:hover": {
            backgroundColor: "unset",
        },
    },
};

class ModalButtonOption extends Component {
    onClick() {
        this.props.onClick(this.props.value);
    }

    render() {
        const { classes } = this.props;

        return (
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 without-padding">
                <Card className={`${classes.card} without-padding`}>
                    <CardContent className={`${classes.cardContent} without-padding`}>
                        <Button
                            color="secondary"
                            className={classes.button + " without-side-padding"}
                            onClick={this.onClick.bind(this)}
                        >
                            {this.props.icon}
                            <Typography color="primary" className={classes.cardTitle}>
                                {this.props.name}
                            </Typography>
                        </Button>
                    </CardContent>
                </Card>
            </div>
        );
    }
}

export default withStyles(styles)(ModalButtonOption);
